/* Recovery Massager — shared interactions */
(function () {
  'use strict';

  function initPlaceholderSvgCrop() {
    document
      .querySelectorAll(
        '.rec-hero__media svg, .rec-problem__media svg, .rec-product__gallery-main svg'
      )
      .forEach(function (svg) {
        svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      });
  }

  function initReveal() {
    var items = document.querySelectorAll('.rec-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('rec-reveal--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('rec-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initStickyAtc() {
    var bar = document.querySelector('[data-rec-sticky-atc]');
    var trigger = document.querySelector('[data-rec-atc-trigger]');
    if (!bar || !trigger) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(trigger);
  }

  function initGallery() {
    document.querySelectorAll('[data-rec-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-rec-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-rec-gallery-thumb]');
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var newSrc = thumb.getAttribute('data-full');
          if (!newSrc) return;
          var img = main.querySelector('img');
          if (img) img.src = newSrc;
          thumbs.forEach(function (t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initHeroKenBurns() {
    var media = document.querySelector('.rec-hero__media img, .rec-hero__media video');
    if (media) media.classList.add('rec-kenburns');
  }

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function initVariantPicker() {
    document.querySelectorAll('[data-rec-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-rec-variants]');
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var variantMediaEl = form.querySelector('[data-rec-variant-media]');
      var variantMedia = {};
      if (variantMediaEl) {
        try {
          variantMedia = JSON.parse(variantMediaEl.textContent);
        } catch (e) {
          variantMedia = {};
        }
      }

      var galleryRoot = form.closest('.rec-product');
      var mediaGallery = galleryRoot ? galleryRoot.querySelector('media-gallery') : null;

      var moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
      var hiddenInput = form.querySelector('[data-rec-variant-id]');
      var priceEl = document.querySelector('[data-rec-price="' + form.dataset.recProductForm + '"]');
      var atcButtons = document.querySelectorAll(
        '[data-rec-atc="' + form.dataset.recProductForm + '"]'
      );
      var stickyPriceEl = document.querySelector(
        '[data-rec-sticky-price="' + form.dataset.recProductForm + '"]'
      );
      var radios = form.querySelectorAll('[data-rec-option]');

      function selectedOptions() {
        var groups = {};
        radios.forEach(function (radio) {
          if (radio.checked) {
            groups[radio.dataset.recOption] = radio.value;
          }
        });
        var positions = Object.keys(groups).sort(function (a, b) {
          return Number(a) - Number(b);
        });
        return positions.map(function (p) {
          return groups[p];
        });
      }

      function findVariant() {
        var selected = selectedOptions();
        if (!selected.length) return variants[0];
        return variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return selected[i] === undefined || opt === selected[i];
          });
        });
      }

      function render() {
        var variant = findVariant();
        if (!variant) return;

        if (hiddenInput) hiddenInput.value = variant.id;

        var priceHtml = formatMoney(variant.price, moneyFormat);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHtml +=
            ' <span class="rec-price--compare">' +
            formatMoney(variant.compare_at_price, moneyFormat) +
            '</span>';
        }
        if (priceEl) priceEl.innerHTML = priceHtml;
        if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price, moneyFormat);

        atcButtons.forEach(function (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available
            ? btn.dataset.labelAvailable
            : btn.dataset.labelSoldOut;
        });
      }

      function switchGalleryMedia() {
        if (!mediaGallery || typeof mediaGallery.setActiveMedia !== 'function') return;
        var variant = findVariant();
        var mediaId = variant && variantMedia[variant.id];
        if (!mediaId) return;
        var sectionId = mediaGallery.id.replace('MediaGallery-', '');
        mediaGallery.setActiveMedia(sectionId + '-' + mediaId, true);
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          render();
          switchGalleryMedia();
        });
      });

      render();
    });
  }

  function initQuantitySteppers() {
    document.querySelectorAll('[data-rec-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-rec-qty-input]');
      var minus = wrap.querySelector('[data-rec-qty-decrease]');
      var plus = wrap.querySelector('[data-rec-qty-increase]');
      if (!input || !minus || !plus) return;

      function clamp(value) {
        var min = parseInt(input.min, 10) || 1;
        if (isNaN(value)) return min;
        return Math.max(min, value);
      }

      minus.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value, 10) - 1);
      });

      plus.addEventListener('click', function () {
        input.value = clamp(parseInt(input.value, 10) + 1);
      });

      input.addEventListener('change', function () {
        input.value = clamp(parseInt(input.value, 10));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPlaceholderSvgCrop();
    initReveal();
    initStickyAtc();
    initGallery();
    initHeroKenBurns();
    initVariantPicker();
    initQuantitySteppers();
  });
})();
